import React, { Fragment, useEffect } from 'react';
import Message, { THEME } from '@mos-cat/message';
import { t, Trans } from '@lingui/macro';
import { connect } from 'dva';
import { Paragraph } from '@mos-cat/typography';
import { createStructuredSelector } from 'reselect';

import {
  getAddressSearchValue,
  isAddressInManualMode,
  isOMKErrorVisible,
  getAddressUnmodeledStreet,
} from '../../../../selectors/addressUnmodeled';
import Link from '../../Link/Link';
import { i18n } from '../../../../helpers/i18n';
import {
  addressOMKError,
  OMKErrorStat,
  sendStats,
} from '../../../../helpers/stats';
import './style.pcss';

interface StateProps {
  isVisible: boolean;
  isManualInput: boolean;
  address: string;
  street: string;
}

interface OwnProps {
  model: 'applicant' | 'spouse' | 'child';
}

type Props = StateProps & OwnProps;

function AddressOMKError(props: Props): JSX.Element | null {
  const { isVisible, isManualInput, address, street } = props;
  useEffect(() => {
    if (isVisible) {
      const payload: OMKErrorStat = isManualInput
        ? { type: 'manual_input', text: street }
        : { type: 'address_suggests', text: address };
      sendStats(addressOMKError(payload));
    }
  }, [isVisible]);
  if (!isVisible) return null;
  return (
    <Fragment>
      <div className="PguFormGrid__row">
        <Message theme={THEME.DANGER} className="AddressMessage">
          <Trans>
            Подача заявления возможна после обращения в Службу технической
            поддержки
          </Trans>
        </Message>
      </div>
      <Paragraph>
        <Trans>
          Сообщите в{' '}
          <Link href={i18n._(t`/feedback/support/`)} target="_blank">
            Службу технической поддержки
          </Link>{' '}
          об отсутствии адреса в справочнике. Техподдержка внесет необходимые
          атрибуты вашего адреса в справочник и сообщит вам о возможности подать
          заявление.
        </Trans>
      </Paragraph>
    </Fragment>
  );
}

const mapStateToProps = createStructuredSelector({
  isVisible: isOMKErrorVisible,
  isManualInput: isAddressInManualMode,
  address: getAddressSearchValue,
  street: getAddressUnmodeledStreet,
});

export default connect(mapStateToProps)(AddressOMKError);
